import { createApp } from 'vue';
import { createPinia } from 'pinia';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';
import '@fontsource/jetbrains-mono/700.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/600.css';
import App from './App.vue';
import { router } from './router';
import i18n from './i18n';
import './styles/theme.css';

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.use(i18n);
app.mount('#app');
